import { z } from 'zod';
import { BRAND_LOGO_SITUATIONS } from '../constants/brandLogoSituations.js';
const colorHex = z
    .string()
    .regex(/^#[0-9A-Fa-f]{6}$/)
    .optional()
    .nullable();
const stringList = z.array(z.string().max(200)).max(50).optional();
export const brandDnaAiScanBodySchema = z.object({
    fetch_website: z.boolean().optional().default(true),
});
export const brandDnaUpdateSchema = z.object({
    tagline: z.string().max(500).optional().nullable(),
    mission: z.string().max(5000).optional().nullable(),
    tone_of_voice: z.string().max(5000).optional().nullable(),
    writing_style: z.string().max(2000).optional().nullable(),
    visual_style: z.string().max(2000).optional().nullable(),
    primary_color: colorHex,
    secondary_color: colorHex,
    accent_color: colorHex,
    font_heading: z.string().max(120).optional().nullable(),
    font_body: z.string().max(120).optional().nullable(),
    target_audience_summary: z.string().max(10000).optional().nullable(),
    value_props: stringList,
    keywords: stringList,
    avoid_phrases: stringList,
    extra: z.record(z.string(), z.unknown()).optional(),
});
export const brandLogosListQuerySchema = z.object({
    project_id: z.string().uuid(),
    account_id: z.string().uuid().optional(),
    scope: z.enum(['project', 'account', 'all']).optional().default('project'),
});
export const brandLogoSituationSchema = z.enum(BRAND_LOGO_SITUATIONS);
//# sourceMappingURL=brandDna.js.map